
import { ISanPhamChiTietActions } from "../../action-types/san-pham/ISanPhamChiTietActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISanPhamChiTietReducer } from "../../reducer-model/san-pham/ISanPhamChiTietReducer";
const iniState: ISanPhamChiTietReducer = {
    status: eReducerStatusBase.is_not_initialization,
    sanPhamChiTiets: []
}
export const sanPhamChiTietReducer = (state: ISanPhamChiTietReducer = iniState, action: ISanPhamChiTietActions): ISanPhamChiTietReducer => {
    switch (action.type) {
        case "SAN_PHAM_CHI_TIET_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SAN_PHAM_CHI_TIET_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                sanPhamChiTiets: action.payload
            }
        case "SAN_PHAM_CHI_TIET_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_CHI_TIET_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                sanPhamChiTietEditing: action.payload
            }
        case "SAN_PHAM_CHI_TIET_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SAN_PHAM_CHI_TIET_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SAN_PHAM_CHI_TIET_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload
            }
        case "SAN_PHAM_CHI_TIET_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_CHI_TIET_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "SAN_PHAM_CHI_TIET_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SAN_PHAM_CHI_TIET_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_CHI_TIET_SHOW_IMPORT_CHITIET_MODAL":
            return {
                ...state,
                isShowImportChiTietModal: true,
            }
        case "SAN_PHAM_CHI_TIET_CLOSE_IMPORT_CHITIET_MODAL":
            return {
                ...state,
                isShowImportChiTietModal: false,
            }
        case "SAN_PHAM_CHI_TIET_SAVE_IMPORT_CHITIET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SAN_PHAM_CHI_TIET_SAVE_IMPORT_CHITIET_SUCCESS":
            return {
                ...state,
                sanPhamChiTietImports: action.payload,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_CHI_TIET_SAVE_IMPORT_CHITIET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }


        default:
            return state;
    }
}